var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "page",
          "show-summary": "",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "colMemberAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.username,
                    uid: row.uid,
                    "vip-level": row.vip_level,
                    "default-detail-tab-type": "betStats",
                  },
                }),
              ]
            },
          },
          {
            key: "colWinAmount",
            fn: function ({ row }) {
              return [
                _c(
                  "span",
                  {
                    class: {
                      "text-positive": (row.win_amount || 0) > 0,
                      "text-negative": (row.win_amount || 0) < 0,
                    },
                  },
                  [
                    row.win_amount > 0 ? _c("span", [_vm._v("+")]) : _vm._e(),
                    row.win_amount < 0 ? _c("span", [_vm._v("-")]) : _vm._e(),
                    _vm._v(_vm._s(_vm.formatAmount(row.win_amount)) + " "),
                  ]
                ),
              ]
            },
          },
          {
            key: "colBetAmount",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.formatAmount(row.bet_amount)))]
            },
          },
          {
            key: "colCreatedAt",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm.formatTimestamp(row.created_at)))]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      size: "mini",
                      type:
                        _vm.formatStatus(row) === "Win" ? "success" : "danger",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.formatStatus(row)) + " ")]
                ),
              ]
            },
          },
          {
            key: "colBetId",
            fn: function ({ row }) {
              return [
                _vm._v(_vm._s(row.bet_id != null ? String(row.bet_id) : "--")),
              ]
            },
          },
        ]),
      }),
      _c("BettingRecordDetailDialog", {
        attrs: {
          visible: _vm.detailVisible,
          "member-account": _vm.detailMemberAccount,
          "member-uid": _vm.detailMemberUid,
        },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }